import { createSlice } from "@reduxjs/toolkit";

const initialDadosPessoalState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  tipoUCForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const dadosPessoalSlice = createSlice({
  name: 'dadosPessoal',
  initialState: initialDadosPessoalState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callTypes === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callTypes === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    tipoUCFetched: (state, action) => {
      state.listLoading = false;
      state.tipoUCForEdit = action.payload.tipoUCForEdit;
      state.error = null;
    },
    dadosPessoalFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    tipoUCCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      // console.log(action);
      state.entities.push(action.payload.tipoUC);
    },
    tipoUCUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.idDadoPessoal === action.payload.tipoUC.idDadoPessoal) {
          return action.payload.tipoUC;
        }
        return entity;
      });
    },
    tipoUCDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id === action.payload.id);
    },
    dadosPessoalStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
  },
});
